// extracted by mini-css-extract-plugin
export var resizer = "_ds-0";